export * from './SelectedProductsSidebarAttachModalButton.types';
export { default as SelectedProductsSidebarAttachModalButton } from './SelectedProductsSidebarAttachModalButton';
